module.exports = __webpack_public_path__ + "static/media/order-header-bg.192af4c3.png";